import { api } from "./api";

export const PLAN_LABEL = { starter: "免費 Starter", trial: "Premium 試用中", premium: "Premium" };

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("zh-TW", { year: "numeric", month: "long", day: "numeric" }) : "");

export const startCheckout = async (interval) => {
  const { data } = await api.post("/billing/checkout", { interval, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};

export const openPortal = async () => {
  const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
  window.location.href = data.url;
};

export const startTrial = () => api.post("/billing/trial");

export const errMsg = (e, fallback = "發生錯誤，請再試一次") => e?.response?.data?.detail || fallback;
